import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import AdxButton from 'components/custom/AdxButton'

const PageNotFound404 = () => {
  const navigate = useNavigate()

  const handleSignUp = () => {
    window.scrollTo(0, 0)
    navigate('/')
  }

  const handleContact = () => {
    window.scrollTo(0, 0)
    navigate('/contact-us')
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        minWidth: '280px',
        px: '20px',
        maxWidth: '450px',
        textAlign: 'center',
        margin: 'auto',
      }}
    >
      <Box
        component="img"
        src={'/adnexio-logo-text.svg'}
        alt="adnexio logo"
        sx={{ position: 'absolute', top: 50, height: '30px' }}
      />
      <Typography
        variant="h1"
        fontWeight="bold"
        fontFamily={'Poppins'}
        fontSize={{ xs: '72px', sm: '96px' }}
        lineHeight={{ xs: '84px', sm: '112px' }}
        color="#000"
        letterSpacing="initial"
      >
        404
      </Typography>
      <Typography
        variant="body1"
        textTransform={'uppercase'}
        fontFamily={'Poppins'}
        fontSize={{ xs: '14px', sm: '16px' }}
        lineHeight={{ sm: '24px' }}
        letterSpacing="initial"
      >
        Page Not Found.
      </Typography>
      <Typography
        variant="body2"
        fontFamily={'Poppins'}
        my={'30px'}
        fontSize={{ xs: '12px', sm: '14px' }}
        lineHeight={{ xs: '17px', sm: '20px' }}
        letterSpacing="initial"
      >
        The page you are trying to access was deleted or never existed. Sorry for the inconvenience!
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '400px' }}>
        <AdxButton onClick={handleSignUp}>Home</AdxButton>
        <AdxButton variant="outlined" onClick={handleContact}>
          Contact Us
        </AdxButton>
      </Box>
    </Box>
  )
}

export default PageNotFound404
